import React from "react";
import { MenuItem, ListItemIcon, useMediaQuery, Box } from "@mui/material";

import { Icon } from "../../icons";
import {
  Avatar,
  LoginRegisterButtons,
  Menu,
  MenuItemInterface,
  MeshGradient,
  getInitials,
} from "../";
import {
  AccountMenuContainer,
  HeaderContainer,
  InfoContainer,
  CustomIconButton,
  StyledLink,
  StyledLinkMenuItem,
  UserMenuContainer,
  BottomContainer,
  MenuLinkTypography,
  MenuWrapper,
  LogoutWrapper
} from "./AccountMenu.styles";
import { UserInterface } from "../../models/User";
import { logoutUser } from "../../utils/auth";
import { useRouter } from "next/router";

export interface CustomVariantAccountMenuProps {
  memberScore?: number | null;
  user?: UserInterface | null;
  hamburgerMenuOnMobile?: boolean;
  menuItems?: MenuItemInterface[];
  showLoginButton?: boolean;
  showRegisterButton?: boolean;
}

export const AccountMenu = ({
  user = null,
  memberScore = 10000,
  hamburgerMenuOnMobile = true,
  showLoginButton = true,
  showRegisterButton = true,
  menuItems = [],
  ...rest
}: CustomVariantAccountMenuProps) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    setAnchorEl(null);
    logoutUser();
  };

  const initials = getInitials(user?.firstName, user?.lastName);

  const smallScreen = useMediaQuery("(max-width:600px)");

  const isLoggedIn = user?.email ? true : false;

  return (
    <>
      <AccountMenuContainer data-cy="account-menu-container">
        {!isLoggedIn && !smallScreen ? (
          <LoginRegisterButtons
            showLoginButton={showLoginButton}
            showRegisterButton={showRegisterButton}
          />
        ) : (
          <CustomIconButton
            data-cy="account-menu-openButton"
            onClick={handleClick}
            aria-controls={open ? "AccountMenu" : undefined}
            aria-haspopup="true"
            aria-expanded={open ? "true" : undefined}
          >
            {smallScreen && hamburgerMenuOnMobile ? (
              open ? (
                <Icon icon="X" />
              ) : (
                <Icon icon="Menu" />
              )
            ) : (
              <Avatar initials={initials} />
            )}
          </CustomIconButton>
        )}
      </AccountMenuContainer>

      <Menu
        data-cy="account-menu"
        anchorEl={anchorEl}
        id="AccountMenu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        elevation={0}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
        variant="noPadding"
      >
        <MenuWrapper>
          {isLoggedIn ? (
            <UserMenuContainer>
              <HeaderContainer>
                <Avatar initials={initials} />
                <InfoContainer>
                  <span className="AccountMenu_username">
                    {user?.firstName} {user?.lastName}
                  </span>
                  {/* <span>
                  Member Score: {memberScore}
                  </span> */}
                </InfoContainer>
              </HeaderContainer>

              <MenuItem
                onClick={handleClose}
                data-cy="account-menu-application-tickets"
              >
                <StyledLink href="/profile?tab=tickets">
                  <ListItemIcon>
                    <Icon icon="Ticket" />
                  </ListItemIcon>
                  Applications & Tickets
                </StyledLink>
              </MenuItem>
              <MenuItem onClick={handleClose} data-cy="account-menu-accountDetails">
                <StyledLink href="/profile?tab=account">
                  <ListItemIcon>
                    <Icon icon="User" />
                  </ListItemIcon>
                  Account Details
                </StyledLink>
              </MenuItem>
              {/* <MenuItem onClick={handleClose} data-cy="account-menu-notifications">
              <StyledLink href="/profile?tab=profile">
                <ListItemIcon>
                  <Icon icon="Bell" />
                </ListItemIcon>
                Profile
              </StyledLink>
            </MenuItem> */}
              <MenuItem
                onClick={handleLogout}
                data-cy="account-menu-logoutButton"
              >
                <LogoutWrapper>
                  <ListItemIcon>
                    <Icon icon="Logout" />
                  </ListItemIcon>
                  Logout
                </LogoutWrapper>
              </MenuItem>
            </UserMenuContainer>
          ) : (
            <LoginRegisterButtons
              showLoginButton={showLoginButton}
              showRegisterButton={showRegisterButton}
            />
          )}
          {smallScreen && (
            <BottomContainer isLoggedIn={isLoggedIn}>
              {menuItems.map((menuItem, index) => (
                <StyledLinkMenuItem
                  key={`link-${menuItem.title}-${index}`}
                  href={menuItem.route}
                >
                  <MenuLinkTypography>{menuItem.title}</MenuLinkTypography>
                </StyledLinkMenuItem>
              ))}
            </BottomContainer>
          )}
        </MenuWrapper>

        <MeshGradient
          colour="pink-purple-green"
          position="bottom"
          size="low"
          sx={{ zIndex: 0 }}
        />
      </Menu>
    </>
  );
};

export interface AccountMenuProps
  extends React.ComponentProps<typeof AccountMenu> {
  as?: React.ElementType;
}

AccountMenu.displayName = "AccountMenu";
